import React from 'react';

const PaymentDataCards = () => {





    return (
      <div className="px-2 py-4 flex justify-between">



            <div className="bg-blue-500 text-white h-24 w-60  p-3 px-3 flex justify-between">
                <div className="flex-1 flex text-center flex-col justify-between">
                    <p className="text-white text-sm font-bold">20000</p>
                    <p className="text-white text-sm">Annual Subscription</p>
                </div>

                <div className="w-0.5 bg-white "></div>

                <div className="flex-1 text-center flex flex-col justify-between">
                    <p className="text-white text-sm font-bold">1.00</p>
                    <p className="text-white text-sm ">Cost/PAX</p>
                </div>
            </div>


            <div className="bg-indigo-500 text-white h-24 w-60  p-3 px-3 flex justify-between">
                <div className="flex-1 text-center flex flex-col justify-between">
                    <p className="text-white text-sm font-bold">11 Dec 2022</p>
                    <p className="text-white text-sm ">Subscription Validity</p>
                </div>
            </div>


            <div className="bg-yellow-500 text-white h-24 w-60  p-3 px-3 flex justify-between">
                <div className="flex-1 text-center flex flex-col justify-between">
                    <p className="text-white text-sm font-bold">30,000 SGD</p>
                    <p className="text-white text-sm ">To Collect</p>
                </div>
            </div>



            <div className="bg-red-500 text-white h-24 w-60  p-3 px-3 flex justify-between">
                <div className="flex-1 text-center flex flex-col justify-between">
                    <p className="text-white text-sm font-bold">30,000 SGD</p>
                    <p className="text-white text-sm ">To Pay</p>
                </div>
            </div>



            <div className="bg-green-500 text-white h-24 w-60  p-3 px-3 flex justify-between">
                <div className="flex-1 text-center flex flex-col justify-between">
                    <p className="text-white text-sm font-bold">30,000 SGD</p>
                    <p className="text-white text-sm ">Net Total (collect-pay)</p>
                </div>
            </div>




      </div>
    );
}

export default PaymentDataCards;
